// this file is automatically generated by version.sh script
export const version: Version = {
  version: '3.2.21',
  revision: 'e5f1ee504',
  branch: 'HEAD',
  timestamp: '05.11.2026'
};

export interface Version {
  revision: string;
  version: string;
  branch: string;
  timestamp: string;
}
